export default __webpack_public_path__ + "static/media/Zac_Huang.20fb8046.png";